import { MeiliSearch } from 'meilisearch';
export function createMeiliSearchIndex(endpoint, token, index) {
    return new MeiliSearch({ host: endpoint, apiKey: token }).index(index);
}
